import './About.css';

function About(){
    return(
        <div className="about" id="about">
            <h1>About</h1>
            <p>As this world continues to grow, we keep gaining memories everyday. However, our past definitely has 
                a unique effect on us :') Sometimes certain songs take us back to times when we were old and naive. 
                80's and 90's songs definitely have a huge impact on songs made today. This website made is just to 
                remember importance of legendary artists while also sticking to the theme of the event. 
            </p>
        </div>
    )
}

export default About;